module.exports = __webpack_public_path__ + "img/media2.3dc6408b.png";